import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ItemCategory\GetItemCategoryListController::__invoke
* @see app/Http/Controllers/ItemCategory/GetItemCategoryListController.php
* @route '/api/item-category'
*/
const GetItemCategoryListController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetItemCategoryListController.url(options),
    method: 'get',
})

GetItemCategoryListController.definition = {
    methods: ["get","head"],
    url: '/api/item-category',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ItemCategory\GetItemCategoryListController::__invoke
* @see app/Http/Controllers/ItemCategory/GetItemCategoryListController.php
* @route '/api/item-category'
*/
GetItemCategoryListController.url = (options?: RouteQueryOptions) => {
    return GetItemCategoryListController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ItemCategory\GetItemCategoryListController::__invoke
* @see app/Http/Controllers/ItemCategory/GetItemCategoryListController.php
* @route '/api/item-category'
*/
GetItemCategoryListController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetItemCategoryListController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ItemCategory\GetItemCategoryListController::__invoke
* @see app/Http/Controllers/ItemCategory/GetItemCategoryListController.php
* @route '/api/item-category'
*/
GetItemCategoryListController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetItemCategoryListController.url(options),
    method: 'head',
})

export default GetItemCategoryListController